// extracted by mini-css-extract-plugin
module.exports = {"flashMessage":"FlashMessage_flashMessage__zNqLc","error":"FlashMessage_error__2Dg5y","warning":"FlashMessage_warning__37fLe","opened":"FlashMessage_opened__2nJ1I"};